import { isPermanentlyRedirectException } from './isPermanentlyRedirectException';
import { isRedirectFoundException } from './isRedirectFoundException';

export const isRedirectException = (statusCode: number) => (
  isPermanentlyRedirectException(statusCode)
  || isRedirectFoundException(statusCode)
);
